import React, { useEffect, useRef, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { IconButton, InputBase, Stack } from '@mui/material';

const DEBOUNCE_MS = 400;

interface IProps {
  setIsSearch: VoidFunction;
  renderCustomInput?: () => any;
  handleChange?: any;
  placeholder?: string;
  selectedValue?: any;
  value?: any;
  isLoading?: boolean;
}

const TableSearchInputComponent = (props: IProps) => {
  const {
    setIsSearch,
    renderCustomInput,
    handleChange,
    placeholder,
    selectedValue,
    value,
    isLoading = false,
  } = props;

  const [text, setText] = useState<string>(value ?? '');
  const handleChangeRef = useRef(handleChange);
  const isFirstRender = useRef(true);

  useEffect(() => {
    handleChangeRef.current = handleChange;
  }, [handleChange]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const timer = setTimeout(() => {
      handleChangeRef.current?.({
        target: { value: text },
        currentTarget: { value: text },
      });
    }, DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [text]);

  return (
    <Stack direction="row" sx={{ alignItems: 'center', flexWrap: 'nowrap' }}>
      {renderCustomInput ? (
        <Stack
          direction="row"
          sx={{
            minWidth: '180px',
            maxWidth: '250px',
            overflowX: 'scroll',
            '&::-webkit-scrollbar': { display: 'none' },
          }}
        >
          {renderCustomInput()}
        </Stack>
      ) : (
        <InputBase
          sx={{ width: '80%' }}
          placeholder={placeholder}
          inputProps={{ 'aria-label': placeholder }}
          onChange={(e) => setText(e.target.value)}
          value={text}
          disabled={isLoading}
        />
      )}
      {!selectedValue?.length && (
        <IconButton
          type="button"
          sx={{ p: '1px' }}
          aria-label="search"
          onClick={setIsSearch}
          disabled={isLoading}
        >
          <CloseIcon />
        </IconButton>
      )}
    </Stack>
  );
};

export default TableSearchInputComponent;
